import React from "react"
import PropTypes from "prop-types"
import clsx from "classnames"

const AmountButton = ({
  active = true,
  children = undefined,
  label = "",
  secondaryLabel = undefined,
  onClick = () => {},
  selected = false,
  /**
   * Amount of buttons that will be displayed in the same row.
   * Used to calculate the width of the button.
   * Default value is 0, where the button will take the full width.
   */
  siblingsCount = 0,
}) => (
  <div
    className={clsx("box-border inline-block p-1", {
      "w-full": siblingsCount === 0,
      "w-1/2": siblingsCount === 1,
      "w-1/3": siblingsCount === 2,
    })}
  >
    <button
      type="button"
      className={clsx(
        "flex h-16 w-full cursor-pointer items-center justify-center rounded-xs border border-solid transition ease-in-out hover:drop-shadow-md",
        {
          "border-blue-600 bg-blue-600 text-white": selected,
          "border-gray-200 bg-white text-black hover:bg-gray-200": !selected,
        },
      )}
      disabled={!active}
      onClick={onClick}
      data-testid={`amount-button-${label}`}
    >
      <span className="font-sans-heading mr-1 flex items-center text-base font-semibold sm:text-lg">
        {label}
      </span>
      {children}
      {secondaryLabel && (
        <span className="font-sans-heading flex items-center text-base font-semibold sm:text-lg">
          {secondaryLabel}
        </span>
      )}
    </button>
  </div>
)

AmountButton.propTypes = {
  active: PropTypes.bool,
  children: PropTypes.node,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  secondaryLabel: PropTypes.string,
  onClick: PropTypes.func,
  selected: PropTypes.bool,
  siblingsCount: PropTypes.number,
}

export default AmountButton
